'use client'

import { isDevelop } from '@/lib/config.shared'
import { env } from '@/lib/env'
import { registerAnalyticsSubscribers } from '@/lib/eventBus/registerAnalyticsSubscribers'

registerAnalyticsSubscribers()

const applicationId = env.NEXT_PUBLIC_DATADOG_APPLICATION_ID
const clientToken = env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN

if (applicationId && clientToken) {
  const service = env.DD_SERVICE
  const ddEnv = env.DD_ENV

  Promise.all([import('@datadog/browser-rum'), import('@datadog/browser-logs')])
    .then(([{ datadogRum }, { datadogLogs }]) => {
      datadogRum.init({
        applicationId,
        clientToken,
        site: env.DD_SITE,
        service,
        env: ddEnv,
        traceSampleRate: isDevelop ? 0 : 10,
        sessionSampleRate: isDevelop ? 0 : 10,
        sessionReplaySampleRate: isDevelop ? 0 : 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackAnonymousUser: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [
          {
            match: `${window.location.origin}/api/`,
            propagatorTypes: ['datadog', 'tracecontext'],
          },
        ],
      })

      datadogLogs.init({
        clientToken,
        site: env.DD_SITE,
        service,
        env: ddEnv,
        sessionSampleRate: isDevelop ? 0 : 10,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error', 'warn'],
      })
    })
    .catch((error) => {
      console.error('Failed to load Datadog modules:', error)
    })
}
